import * as API from '@/services/API';

export default {
  getStatesByCountry(country) {
    return API.apiClient.get(`/states?country=${country}`);
  }
};
